import React from 'react';

export default function Switch ({
    stato , 
    onChangeValue,  
    number , 
    label ,
    classe ,
    width = '15%'
}) {
    //console.log(stato , ' stato ', number );
    
    const handleCambiavalore = () => onChangeValue(stato ? 0 : 1, number);

    return (
        <>
            <div className={"form-check form-switch d-flex flex-column justify-content-between align-items-center " + classe} style={{width : width , marginBottom : '1rem'}}>
                <label className="form-check-label" htmlFor={"customSwitch"+number}>{label}</label>
                <input checked={!!stato} onChange={handleCambiavalore} className="form-check-input m-auto mt-4 mb-5"
                 type="checkbox" role="switch" id={"customSwitch"+number}/>
            </div>
        </>
    )
}